// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sF1L","question":"styles_question__3dTq3","inputVisibleButton":"styles_inputVisibleButton__1Xsw7","note":"styles_note__3zEI_"};